// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 21/6/2023
 */

.Management_pageContainer__JlZoP {
    margin: 1rem;
    min-height: 90.2vh;
    padding: 1rem 0;
}

.Management_subNavBar__6U2V0 {
    /* height: 5rem; */
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;
}

.Management_topic__8HTqv {
    font-style: normal;
    font-weight: 600;
    padding: 1rem 1.5rem;
    padding-left: 0;
    font-size: 1.5rem;
    line-height: 29px;
}

#Management_container__m3Qcy {
    padding: 0;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.Management_gridContent__rPSBA {
    margin: 0.5rem;
    height: 25rem;
    margin: 1rem;
    border-radius: 0.5rem;
}

.Management_buttonItem__3jHwu {
    margin: 0.5rem 0 ;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    border-radius: 0.5rem;
    justify-self: center;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Management.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;AACxB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 21/6/2023\r\n */\r\n\r\n.pageContainer {\r\n    margin: 1rem;\r\n    min-height: 90.2vh;\r\n    padding: 1rem 0;\r\n}\r\n\r\n.subNavBar {\r\n    /* height: 5rem; */\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.topic {\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    padding: 1rem 1.5rem;\r\n    padding-left: 0;\r\n    font-size: 1.5rem;\r\n    line-height: 29px;\r\n}\r\n\r\n#container {\r\n    padding: 0;\r\n    padding-left: 1rem;\r\n    margin-top: 2rem;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.gridContent {\r\n    margin: 0.5rem;\r\n    height: 25rem;\r\n    margin: 1rem;\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.buttonItem {\r\n    margin: 0.5rem 0 ;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 1rem;\r\n    border-radius: 0.5rem;\r\n    justify-self: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `Management_pageContainer__JlZoP`,
	"subNavBar": `Management_subNavBar__6U2V0`,
	"topic": `Management_topic__8HTqv`,
	"container": `Management_container__m3Qcy`,
	"gridContent": `Management_gridContent__rPSBA`,
	"buttonItem": `Management_buttonItem__3jHwu`
};
export default ___CSS_LOADER_EXPORT___;
